// Simple validation script for Herslev Bryghus
// Ensures customers cannot checkout with a beer tap system without at least one keg

document.addEventListener('DOMContentLoaded', function() {
  // Configuration
  const beerTapSystem = 'leje-af-fadolsanlaeg';
  const kegsCollection = 'fustager';
  const errorMessage = 'Du skal tilføje mindst én fustage til din kurv for at kunne leje et fadølsanlæg.';
  const kegsUrl = 'https://hyggeligsvalen.shop/collections/fustager';
  
  // Check cart on page load
  checkCart();
  
  // Listen for cart changes
  document.addEventListener('cart:updated', checkCart);
  document.addEventListener('cart:refresh', checkCart);
  
  // Listen for AJAX cart updates
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const promise = originalFetch.apply(this, arguments);
    
    if (typeof url === 'string' && (
      url.includes('/cart/change') || 
      url.includes('/cart/add') || 
      url.includes('/cart/update')
    )) {
      promise.then(() => setTimeout(checkCart, 500));
    }
    
    return promise;
  };
  
  // Main function to check cart and manage checkout button
  function checkCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const validation = validateCart(cart);
        
        // Show or hide warning message in cart
        toggleCartWarning(!validation.valid, validation.message);
        
        // Handle checkout button state
        const checkoutButtons = document.querySelectorAll('button[name="checkout"], a[href="/checkout"]');
        
        checkoutButtons.forEach(button => {
          if (!validation.valid) {
            // Invalid cart: disable checkout button and add click handler
            button.addEventListener('click', showErrorModal);
            
            // Add data attribute to mark as handled
            button.setAttribute('data-cart-validation', 'invalid');
          } else {
            // Valid cart: remove click handler
            button.removeEventListener('click', showErrorModal);
            button.removeAttribute('data-cart-validation');
          }
        });
      });
  }
  
  // Check if the cart is valid
  function validateCart(cart) {
    if (!cart.items || cart.items.length === 0) {
      return { valid: true, message: '' };
    }
    
    let hasBeerTap = false;
    let hasKeg = false;
    
    cart.items.forEach(item => {
      // Check for beer tap system
      if (item.handle === beerTapSystem || 
          (item.product_title && item.product_title.toLowerCase().includes('fadølsanlæg'))) {
        hasBeerTap = true;
      }
      
      // Check for kegs
      if ((item.product_type && item.product_type.toLowerCase().includes('fustage')) || 
          (item.url && item.url.toLowerCase().includes(kegsCollection))) {
        hasKeg = true;
      }
    });
    
    // Invalid if has beer tap but no kegs
    if (hasBeerTap && !hasKeg) {
      return { valid: false, message: errorMessage };
    }
    
    return { valid: true, message: '' };
  }
  
  // Show or hide warning in cart
  function toggleCartWarning(show, message) {
    // Remove existing warning
    const existingWarning = document.getElementById('cart-warning');
    if (existingWarning) {
      existingWarning.remove();
    }
    
    if (!show) return;
    
    // Create warning element
    const warning = document.createElement('div');
    warning.id = 'cart-warning';
    warning.className = 'cart-warning';
    warning.innerHTML = `<p>${message}</p>`;
    
    // Add styles if not already added
    if (!document.getElementById('cart-validation-styles')) {
      const style = document.createElement('style');
      style.id = 'cart-validation-styles';
      style.textContent = `
        .cart-warning {
          background-color: #FFF3CD;
          color: #856404;
          padding: 12px;
          margin: 10px 0;
          border-radius: 4px;
          border-left: 4px solid #F0AD4E;
        }
        
        .cart-warning p {
          margin: 0;
          font-size: 14px;
        }
        
        #cart-error-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 99999;
        }
        
        .modal-content {
          background-color: white;
          padding: 30px;
          border-radius: 5px;
          max-width: 90%;
          width: 450px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
          text-align: center;
        }
        
        .kegs-button {
          margin-top: 0px;
          padding: 10px 20px;
          background-color: #333;
          color: white;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          font-size: 16px;
          text-decoration: none;
          display: inline-block;
        }
        
        .kegs-button:hover {
          background-color: #555;
        }
      `;
      document.head.appendChild(style);
    }
    
    // Insert warning in cart
    const cartDrawer = document.querySelector('.drawer__inner, #CartDrawer, .cart-drawer');
    const cartForm = document.querySelector('form[action="/cart"], #cart_form');
    
    if (cartDrawer) {
      cartDrawer.insertAdjacentElement('afterbegin', warning);
    } else if (cartForm) {
      cartForm.insertAdjacentElement('afterbegin', warning);
    }
  }
  
  // Show error modal
  function showErrorModal(event) {
    // Prevent default action and stop propagation
    event.preventDefault();
    event.stopPropagation();
    
    // Create modal
    const modal = document.createElement('div');
    modal.id = 'cart-error-modal';
    modal.innerHTML = `
      <div class="modal-content">
        <p>${errorMessage}</p>
        <a href="${kegsUrl}" class="kegs-button">Se fustager</a>
      </div>
    `;
    
    // Add to page
    document.body.appendChild(modal);
    
    // Close when clicking outside modal
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        modal.remove();
      }
    });
    
    // Prevent event from continuing
    return false;
  }
  
  // Add global click handler for checkout buttons that might be added dynamically
  document.addEventListener('click', function(e) {
    // Check if target is a checkout button
    const isCheckoutButton = 
      (e.target.name === 'checkout' || 
       e.target.getAttribute('href') === '/checkout' ||
       (e.target.closest && (
         (e.target.closest('button[name="checkout"]') || 
          e.target.closest('a[href="/checkout"]'))
       )));
    
    // Skip if not a checkout button
    if (!isCheckoutButton) return;
    
    // Check if the button has been marked as invalid
    const isInvalid = 
      e.target.getAttribute('data-cart-validation') === 'invalid' ||
      (e.target.closest && e.target.closest('[data-cart-validation="invalid"]'));
    
    // If invalid, prevent checkout and show modal
    if (isInvalid) {
      e.preventDefault();
      e.stopPropagation();
      showErrorModal(e);
      return false;
    }
  }, true);
});